// slackBlocks.ts
import type {
  KnownBlock,
  SectionBlock,
  DividerBlock,
  ContextBlock,
  ActionsBlock,
  MrkdwnElement,
  Button,
} from '@slack/types'

export const mrkdwn = (text: string): MrkdwnElement => ({
  type: 'mrkdwn',
  text,
})

export const section = (text: string): SectionBlock => ({
  type: 'section',
  text: mrkdwn(text),
})

export const divider = (): DividerBlock => ({
  type: 'divider',
})

export const context = (texts: string[]): ContextBlock => ({
  type: 'context',
  elements: texts.map(t => mrkdwn(t)),
})

export const button = (label: string, url: string): Button => ({
  type: 'button',
  text: { type: 'plain_text', text: label },
  url,
})

export const actions = (btns: Button[]): ActionsBlock => ({
  type: 'actions',
  elements: btns,
})

// utility to clone/replace placeholder safely
export const replaceInBlocks = (blocks: KnownBlock[], placeholder: string, value: string): KnownBlock[] =>
  JSON.parse(JSON.stringify(blocks).replaceAll(placeholder, value))
